/**
 * Crea una nota de crédito (anulación de factura electrónica) para una venta.
 */
export async function createCreditNote(authFetch, orderId, token) {
  const response = await authFetch(
    `ventas/${orderId}/nota-credito`,
    {},
    "POST",
    token
  );

  let data = {};
  try {
    data = await response.json();
  } catch {
    data = {};
  }

  if (!response.ok) {
    const message =
      data?.error?.message ||
      data?.message ||
      "No se pudo generar la nota de crédito";
    const err = new Error(message);
    err.status = response.status;
    throw err;
  }

  return data;
}

export function userCanCreateCreditNote(user) {
  if (!user?.roles) {
    return false;
  }
  const allowed = ["admin", "administradorTienda", "superAdmin"];
  return user.roles.some((role) => allowed.includes(role));
}
